import { client } from './index';
import {
  ChatbotConversation,
  ChatbotMessage,
  ChatbotModuleContext,
  PollMessageResponse,
  ReportIssueRequest,
  SendMessageResponse,
} from '../types/askDataScope';

export const askDataScopeApi = {
  getConversations: () =>
    client.get<ChatbotConversation[]>('/chatbot/conversations'),

  createConversation: (moduleContext?: ChatbotModuleContext) =>
    client.post<{ id: number; module_context: ChatbotModuleContext }>('/chatbot/conversations', {
      module_context: moduleContext,
    }),

  getMessages: (conversationId: number) =>
    client.get<ChatbotMessage[]>(`/chatbot/conversations/${conversationId}/messages`),

  sendMessage: (conversationId: number, content: string, options?: { start_date?: string | null; end_date?: string | null; module_context?: ChatbotModuleContext }) =>
    client.post<SendMessageResponse>(`/chatbot/conversations/${conversationId}/messages`, {
      content,
      start_date: options?.start_date || undefined,
      end_date: options?.end_date || undefined,
      module_context: options?.module_context ?? undefined,
    }),

  pollMessage: (conversationId: number, messageId: number) =>
    client.get<PollMessageResponse>(
      `/chatbot/conversations/${conversationId}/messages/${messageId}/poll`,
    ),

  reportIssue: (conversationId: number, data: ReportIssueRequest) =>
    client.post<{ success: boolean }>(`/chatbot/conversations/${conversationId}/report`, data),
};
